export const GET_SAVED_SEARCH_LIST = 'GET_SAVED_SEARCH_LIST';
export const SAVE_SEARCH_CRITERIA = 'SAVE_SEARCH_CRITERIA';
export const STORE_SAVED_SEARCH_LIST = 'STORE_SAVED_SEARCH_LIST';
export const DELETE_SAVED_SEARCH_LIST = 'DELETE_SAVED_SEARCH_LIST';
